import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ReportTicketComparativeRepository} from "@dropDesk/domain/repositories/reports/report_ticket_comparative/report_ticket_comparative.repository";
import {
    ReportTicketComparativeRemoteDataSource
} from "@dropDesk/data/data_source/reports/report_ticket_comparative/report_ticket_comparative_remote.datasource";
import {
    ReportTicketComparativeEntity
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/report_ticket_comparative.entity";
import {ServerError} from "@dropDesk/domain/entities/exceptions/exceptions";
import {ReportEntityFilters} from "@dropDesk/presentation/components/filters/report_entity_filters";

@injectable()
export class ReportTicketComparativeRepositoryImpl implements ReportTicketComparativeRepository {
    private _dataSource: ReportTicketComparativeRemoteDataSource;

    constructor(
        @inject(ReportTicketComparativeRemoteDataSource)
        dataSource: ReportTicketComparativeRemoteDataSource
    ) {
        this._dataSource = dataSource;
    }

    public get(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<ReportTicketComparativeEntity> {
        try {
            return this._dataSource.get(period, comparePeriod, filters);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }

    public exportHtml(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<void> {
        try {
            return this._dataSource.exportHtml(period, comparePeriod, filters);
        } catch (e: any) {
            throw new ServerError(e.message);
        }
    }
}
